module.exports = __webpack_public_path__ + "static/media/fly.1cc9604e.svg";